import React from "react";
import ReactECharts from "echarts-for-react";
import bays from "../../Artifacts/scvpu/zoneDashboard/iconbays.svg";

export default function DonutChart({
  data = [],
  title,
  saliance,
  total_dealer,
}) {
  // Calculate total for center text or legend percentages if needed
  const totalValue = data.reduce((acc, item) => acc + (item.value || 0), 0);

  const option = {
    tooltip: { trigger: "item" },
    legend: {
      orient: "vertical",
      right: "5%",
      left: "45%",
      top: "center",
      itemWidth: 10,
      itemHeight: 10,
      // Function to show "Name: Value" in the legend
      formatter: (name) => {
        const item = data.find((d) => d.name === name);
        return item ? `${name}: ${item.value}` : name;
      },
      textStyle: {
        fontSize: 11,
        color: "#666",
      },
    },
    series: [
      {
        name: title || "Source",
        type: "pie",
        radius: ["50%", "80%"], // Adjusted for better fit
        center: ["25%", "60%"],
        avoidLabelOverlap: false,
        padAngle: 2,
        itemStyle: {
          borderRadius: 6,
        },
        label: {
          show: false, // Set to true if you want text in the hole
          position: "center",
        },
        labelLine: { show: false },
        data: data,
      },
    ],
  };

  return (
    <div className="bg-white rounded-xl shadow p-2 flex flex-col gap-2">
      {/* Header */}
      <div className=" ml-2 flex items-center gap-2">
        <img alt="icon" className="w-6 h-6" src={bays} />
        <h3 className="font-semibold text-[#505050] text-sm">{title}</h3>
      </div>

      <ReactECharts option={option} style={{ height: 100, width: "100%" }} />

      {/* Footer Metrics */}
      <div className="flex justify-between items-center  border-t border-gray-100 ">
        <div className="flex items-center gap-2">
          <span className="text-[10px] text-gray-500 uppercase tracking-wider">
            Saliance
          </span>
          <span className="text-sm font-bold text-gray-800">
            {saliance || "0%"}
          </span>
        </div>
        <div className="flex items-center gap-2 text-right">
          <span className="text-[10px] text-gray-500 uppercase tracking-wider">
            Total Dealer
          </span>
          <span className="text-sm font-bold text-gray-800">
            {total_dealer || 0}
          </span>
        </div>
      </div>
    </div>
  );
}
